import * as React from 'react'
import { ContactFiona } from 'ui/multi-product/constants'
import { formattedPhoneNumber } from 'ui/multi-product/utils'
import {
  aprDisclosure,
  autoPaymentDisclosure,
  generateClosingDisclosure,
  helocDisclosure,
  representativeExample,
} from '../Templates'

export const FionaPersonalLoanDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a loan request on www.fiona.com. The actual loan rate depends on the
      loan amount and term requested, as well as your credit score, usage and history. If you are offered a loan, you
      will have the opportunity to review the final offer made by lender or lending partner, and to accept the loan
      agreement made directly between you and the lender or lending partner. The lenders and lending partners we work
      with may charge an origination fee for facilitating the loan to you. For example, on a $10,000 loan with a 5%
      origination fee, you will incur a $500 origination fee and receive $9,500 upon successful issuance of your loan.
      Rate, terms and fees will be based on your individual credit history and underwritten by the lender and not by
      Engine by MoneyLion / Fiona (“Engine”, “Engine by MoneyLion”, ”Fiona”, “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders', lending partners' or other financial related partners' privacy policy and security
      practices may differ from Fiona standards. Fiona assumes no responsibility, nor does it control, endorse or
      guarantee any aspect of your use of the linked site. All rates, fees, and terms are presented without guarantee
      and are subject to change pursuant to each provider's discretion and may not be available in all states or for all
      types of loans. There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms
      presented. This website does not include all lending companies or all available lending offers that may be
      available to you. Certain products and services may not be available in all U.S. States. We may also share, with
      your consent, your information with or show you offers for other financial related services such as debt relief,
      debt settlement, credit repair or credit monitoring. All our financial partners may contact you by call, text or
      email.
    </p>
    {representativeExample}
    {aprDisclosure}
    <p>
      Requirements, discounts, credit, debt solutions, settlements or other terms and conditions will vary by financial
      provider. We recommend that you read the financial partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    {helocDisclosure}
    {generateClosingDisclosure(formattedPhoneNumber(ContactFiona.Phone))}
  </>
)

export const FionaSLRDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on engine.tech /
      www.hifiona.com. The actual loan rate depends on the loan amount and term requested, as well as your credit score,
      usage, and history. If you are offered a loan, you will have the opportunity to review the final offer made by
      lender or lending partner, and to accept the loan agreement made directly between you and the lender or lending
      partner. The lenders and lending partners we work with may charge an origination fee for facilitating the loan to
      you. For example, on a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee and receive
      $9,500 upon successful issuance of your loan. Rate, terms and fees will be based on your individual credit history
      and underwritten by the lender and not by Engine by MoneyLion / Fiona (“Engine”, "Engine by MoneyLion", ”Fiona”,
      “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Fiona
      standards. Fiona assumes no responsibility, nor does it control, endorse or guarantee any aspect of your use of
      the linked site. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to
      each provider's discretion and may not be available in all states or for all types of loans. There is no guarantee
      you will be approved or qualify for the advertised rates, fees, or terms presented. This website does not include
      all lending companies or all available lending offers that may be available to you. Certain products and services
      may not be available in all U.S. States.
    </p>
    {representativeExample}
    {aprDisclosure}
    <p>
      Student loan refinancing or consolidation may result in certain penalties, restrictions, changes in payments, loss
      of certain benefits, and/or eligibility that may apply for certain federal and private loans. Some requirements
      and restrictions may include loan minimum and maximum requirements, age, degree and educational institution
      requirements, citizenship and residency requirements as well as other lender requirements. Our student loan
      refinance partners offer fixed rates ranging from 2.83%-8.77% and variable interest rates ranging from
      1.97%-8.94%. Variable rates will fluctuate over the term of the loan. Students may also qualify for Federal
      student financial assistance. Additional information can be found at{' '}
      <a href="https://studentaid.gov" target="_blank">
        https://studentaid.gov
      </a>
    </p>
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender.
    </p>
    <p>
      We recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    {generateClosingDisclosure(formattedPhoneNumber(ContactFiona.Phone))}
  </>
)

export const FionaAutoRefiDisclosure = (
  <>
    <p>
      We do not charge any fee or cost to submit a refinance/consolidation loan request on engine.tech / www.fiona.com.
      The actual loan rate depends on the loan amount and term requested, as well as your credit score, usage, history
      and other factors. If you are offered a loan, you will have the opportunity to review the final offer made by
      lender or lending partner, and to accept the loan agreement made directly between you and the lender or lending
      partner. The lenders and lending partners we work with may charge an origination fee for facilitating the loan to
      you. For example, on a $10,000 loan with a 5% origination fee, you will incur a $500 origination fee and receive
      $9,500 upon successful issuance of your loan. Rate, terms and fees will be based on your individual credit history
      and underwritten by the lender and not by Engine by MoneyLion / Fiona (“Engine”, “Engine by MoneyLion”, ”Fiona”,
      “we”, “us”, “our”)
    </p>
    <p>
      Please note, our lenders' and lending partners' privacy policy and security practices may differ from Fiona
      standards. Fiona assumes no responsibility, nor does it control, endorse or guarantee any aspect of your use of
      the linked site. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to
      each provider's discretion and may not be available in all states or for all types of loans. There is no guarantee
      you will be approved or qualify for the advertised rates, fees, or terms presented. Rates may change depending on
      several factors such as having a cosigner. Our partners offer both fixed and variable rates. Variable rates will
      fluctuate over the term of the loan.This website does not include all lending companies or all available lending
      offers that may be available to you. Certain products and services may not be available in all U.S. States.
    </p>
    {representativeExample}
    {aprDisclosure}
    {autoPaymentDisclosure}
    <p>
      Refinancing any loan may not always result in lower overall interest and principal payments and in many cases it
      can extend the life of the loan. Requirements, discounts or other terms and conditions will vary by lender. We
      recommend that you read the lender's and/or lending partner's personal terms and conditions, as well as any
      disclosures, in full before proceeding for any loan.
    </p>
    <p>
      Please note that any type of secured loan is tied to a financial asset that you already own and will be used as
      collateral to pay your loan should you not be able to pay. In some cases, a lender may keep a lien on the
      collateral until the loan is fully repaid.
    </p>
    {generateClosingDisclosure(formattedPhoneNumber(ContactFiona.Phone))}
  </>
)
